<!--
 * @Author:MX
 * @Date: 2020-08-01 11:25:22
 * @Description: 修改密码
-->
<template>
  <div class="modifyPassword">
    <i class="iconfont iconfanhui" @click="reBack"></i>
    <div class="title">{{ $lang('修改密码') }}</div>
    <div class="is-email" @click="isEmail = !isEmail">{{ isEmail ? $lang('切换短信验证') : $lang('切换邮箱验证') }}</div>
    <el-form v-if="!isEmail" ref="forgetPwdForm" :model="forgetPwdForm" :rules="rules">
      <el-form-item prop="mobile">
        <el-input :placeholder="$lang('请输入手机号')" v-model="forgetPwdForm.mobile" autocomplete="off" maxlength="11">
          <i slot="prefix" class="iconfont el-input__icon iconyonghuming"></i>
        </el-input>
        <span class="getPhoneCode" @click="getPhoneCode" :loading="loading" v-if="regainGetCode" :title="$lang('获取手机验证码')">{{ $lang('获取手机验证码') }}</span>
        <span class="getPhoneCode" v-else>{{ time }}s</span>
      </el-form-item>
      <!-- <el-form-item prop="captcha">
     <el-input :placeholder="$lang('请输入图片验证码')" v-model="codeForm.captcha" autocomplete="off" maxlength="11">
         <i slot="prefix" class="iconfont el-input__icon iconyanzhengma1"></i>
         <i slot="suffix">
          <img :src="verificationImg" alt="" @click="resetCode" style="position: relative;bottom: 1px;">
         </i>
     </el-input>
    </el-form-item> -->
      <el-form-item prop="verifyCode">
        <el-input v-model="forgetPwdForm.verifyCode" type="text" :placeholder="$lang('请输入手机验证码')" autocomplete="new-password">
          <i slot="prefix" class="iconfont el-input__icon iconyanzhengma1"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="pwd">
        <el-input v-model="forgetPwdForm.pwd" :placeholder="$lang('请输入新密码')" type="password" autocomplete="new-password">
          <i slot="prefix" class="iconfont el-input__icon iconmima1"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="passwordS">
        <el-input v-model="forgetPwdForm.passwordS" :placeholder="$lang('确认新密码')" autocomplete="new-password" type="password">
          <i slot="prefix" class="iconfont el-input__icon iconmima1"></i>
        </el-input>
      </el-form-item>
    </el-form>
    <el-button v-if="!isEmail" type="primary" class="login-btn" @click="sureModify">{{ $lang('确定') }}</el-button>
    <!-- 邮箱修改密码 -->
    <div>
      <EmailModifyPassword v-if="isEmail" @reBack="reBack"/>
    </div>
  </div>
</template>

<script type="text/javascript">
import { RULES } from '@utils/rules'
import * as Api from '@api/base/public'
import { RESPONSE_SUCCESS } from '@constants'
import EmailModifyPassword from './EmailModifyPassword'
export default {
  name: 'ModifyPassword',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value !== this.forgetPwdForm.pwd) {
        callback(new Error(this.$lang('两次密码输入不一致!')))
      } else {
        callback()
      }
    }
    return {
      time: 60,
      regainGetCode: true,
      loading: false,
      submitLoading: false,
      forgetPwdForm: {
        mobile: '',
        verifyCode: '',
        pwd: '',
        passwordS: '',
      },
      codeForm: {
        ctoken: '',
        captcha: '',
      },
      rules: {
        mobile: [RULES.required, RULES.checkPhone],
        verifyCode: [RULES.required],
        pwd: [RULES.required, RULES.checkPassword],
        passwordS: [RULES.required, RULES.checkPassword, { validator: validatePass, trigger: 'blur' }],
      },
      verificationImg: '', // 验证码图片
      captcha: '', // 腾讯验证码
      captchaType: 0,
      isEmail: true,
    }
  },
  components: {
    EmailModifyPassword,
  },
  computed: {
    // 国际化语言
    lang() {
      return this.$store.state.base.lang
    },
  },
  // created() {
  //   this.getCode()
  // },
  mounted() {
    this.initTencentCaptcha()
  },
  methods: {
    // 初始化tx验证码
    initTencentCaptcha() {
      // 生成实例对象
      const LanguageList = { ES: 'es', EN: 'en', CN: 'zh-cn' }
      this.captcha = this.$Captcha.init(this.tencentCaptchaCallback, { userLanguage: LanguageList[this.lang] })
    },
    // 验证码回调
    async tencentCaptchaCallback(res) {
      console.log('腾讯验证码回调：callback', res)
      // 验证成功，返回对象
      if (res.ret === 0) {
        // 定义参数：票据 随机字符串
        const customParams = {
          ticket: res.ticket,
          randstr: res.randstr,
        }
        if (this.captchaType === 0) {
          this.getCodeFn(customParams)
        } else {
          this.submitData(customParams)
        }
      }
      // 验证不成功
      return null
    },
    // 获取验证码
    async getCodeFn(customParams) {
      this.loading = true
      const { mobile } = this.forgetPwdForm
      const params = {
        mobile,
        // cToken: this.codeForm.ctoken,
        // captcha: this.codeForm.captcha,
        // imageVerifyCode: this.codeForm.captcha
        ...customParams,
      }
      const { code, msg } = await Api.getCodeUpdatePwd(params)
      this.loading = false
      if (code === RESPONSE_SUCCESS) {
        this.regainGetCode = false
        clearInterval(this.codeTimer)
        this.codeTimer = setInterval(() => {
          this.time--
          if (this.time === 0) {
            this.time = 60
            this.regainGetCode = true
            clearInterval(this.codeTimer)
          }
        }, 1000)
      } else {
        this.$message.error(msg)
        this.resetCode()
      }
    },
    /**
     * @description 返回
     */
    reBack() {
      this.$emit('reBack')
    },
    toverification() {
      this.$emit('toverification')
    },
    /**
     * @description 获取手机短信验证码
     */
    async getPhoneCode() {
      const { mobile } = this.forgetPwdForm
      if (!mobile) {
        return this.$message.error(this.$lang('请输入手机号'))
      }
      this.captchaType = 0
      // if (!this.codeForm.captcha) {
      //   return this.$message.error(this.$lang('请输入图片验证码'))
      // }
      this.captcha.show()
    },
    /**
     * @description 确定
     */
    async sureModify() {
      // this.toverification()
      this.$refs['forgetPwdForm'].validate((valid) => {
        if (valid) {
          this.captchaType = 1
          this.captcha.show()
          // this.toverification()
        } else {
          return false
        }
      })
    },
    childMethod(value) {
      // alert(value)
      // alert(555555)
      this.$emit('toverification', 1212)
      this.$parent.verification(12121)
      console.log(value)
      this.submitData(value)
    },
    async submitData(customParams) {
      this.submitLoading = true
      const { verifyCode, pwd, passwordS, mobile } = this.forgetPwdForm
      const params = {
        countryCode: this.phoneValue, // 区号
        // imageVerifyCode: dataVal.captcha, // 图形验证码
        smsCode: verifyCode, // 短信验证码
        password: this.$md5(pwd + 'jadada236t2').toUpperCase(),
        mobile, // 手机号
        confirmPassword: this.$md5(passwordS + 'jadada236t2').toUpperCase(),
        ...customParams,
        // ctoken: dataVal.ctokenTo
      }
      const { code, msg } = await Api.updatePwdByMobile(params)
      this.submitLoading = false
      if (code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('密码修改成功'))
        // this.verificationVisible = false
        this.$emit('reBack')
      } else {
        this.$message.error(msg)
        this.resetCode()
      }
    },
    /**
     * 获取图片验证码
     */
    async getCode() {
      await Api.getCaptcha().then((res) => {
        this.verificationImg = res.data.img
        this.codeForm.ctoken = res.data.ctoken
      })
    },
    /**
     * 重新获取图片验证码
     */
    resetCode() {
      // this.getCode()
    },
  },
  beforeDestroy() {
    clearInterval(this.codeTimer)
  },
}
</script>

<style lang="scss" scoped>
.modifyPassword {
  .title {
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
    text-align: center;
    letter-spacing: 6px;
    height: 70px;
  }
  .login-btn {
    width: 100%;
    padding: 0;
    height: 40px;
    line-height: 40px;
    border: none;
    border-radius: 4px;
    background: linear-gradient(90deg, rgba(230, 0, 18, 1) 0%, rgba(230, 0, 18, 1) 100%);
    font-size: 16px;
  }
  .getPhoneCode {
    position: absolute;
    cursor: pointer;
    right: 0;
    padding: 0 15px;
    bottom: 0px;
    color: #e60012;

    white-space: nowrap;
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .iconfont.iconfanhui {
    position: absolute;
    left: 40px;
    font-size: 25px;
    cursor: pointer;
    color: #e60012;
  }
  .is-email {
    cursor: pointer;
    text-align: center;
    margin-bottom: 30px;
    color: #e60012;
  }
}
</style>
